var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-17"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-17",
    cx: 253.74,
    cy: 341.76,
    rx: 235.29,
    ry: 135.85,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-17"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-17",
    cx: 408.88,
    cy: 369.84,
    rx: 66.75,
    ry: 38.54,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-17",
    points: "239.95 390.63 164.65 347.14 250.72 297.45 326.03 340.93 239.95 390.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-17",
    points: "34.91 377.18 132.03 433.25 213.49 386.23 116.37 330.16 34.91 377.18",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bookshelf--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bookshelf--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.9,165.09,264.29,133a3,3,0,0,0-3-.29l-4,2.31a3,3,0,0,0-1.27,2.77V290a9.45,9.45,0,0,0,4.28,7.4l55.6,32.05a3,3,0,0,0,3,.3l4-2.32a3,3,0,0,0,1.25-2.76V172.49A9.44,9.44,0,0,0,319.9,165.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,292.61l-4,2.31v12.66a2.36,2.36,0,0,0,1.07,1.85l1.87,1.08a2.37,2.37,0,0,0,2.14,0l1.87-1.08a3.8,3.8,0,0,0,1.47-1.79l3.61-10.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,307.58a2.36,2.36,0,0,0,1.07,1.85l1.87,1.08a1,1,0,0,0,1.47-.55L272,299.55l-8-4.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.12,315.7l-4,2.32v12.65a2.37,2.37,0,0,0,1.06,1.86l1.88,1.08a2.35,2.35,0,0,0,2.13,0l1.88-1.08a3.8,3.8,0,0,0,1.47-1.79l3.6-10.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.12,330.67a2.37,2.37,0,0,0,1.06,1.86l1.88,1.08a1,1,0,0,0,1.47-.55l3.61-10.41-8-4.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.56,135.43l55.6,32a9.47,9.47,0,0,1,4.28,7.41V327.05a2.61,2.61,0,0,1-4.28,2.47l-55.6-32.06a9.44,9.44,0,0,1-4.27-7.4V137.89a2.6,2.6,0,0,1,4.27-2.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "179.82 343.48 239.96 378.2 324.16 329.59 320.15 327.27 260.01 292.55 179.82 338.85 179.82 343.48",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.96 378.2 239.96 373.57 324.16 324.96 324.16 329.59 239.96 378.2",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M240.34,371.46l-.61-.41C250.4,354.9,250.33,327,249.46,320c-.07-.47-.12-.76-.13-.87l.73-.12c0,.22.08.48.12.79.78,4.95,5.19,31.84,10.41,40l-.62.4c-4.13-6.41-7.66-23.71-9.43-33.69C250.65,337.84,249,358.43,240.34,371.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.46,346.8c-.91-.27-22.17-6.71-24.13-16.09l.73-.15c1.86,8.95,23.39,15.47,23.61,15.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,343l-.54-2.29a1.89,1.89,0,0,0-1.76-1.56,1.74,1.74,0,0,0-1.78.89l-.69-.29a2.48,2.48,0,0,1,2.53-1.34,2.6,2.6,0,0,1,1.89,1A3.68,3.68,0,0,1,255,337a1.85,1.85,0,0,1,1.82.06l-.33.66a1.16,1.16,0,0,0-1.13-.07c-.85.48-1.18,2.33-1.23,3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.09,350.63l-.66-2.08c-.75-2.35-2-3.7-3.48-3.79a3.18,3.18,0,0,0-2.95,1.85l-.67-.32A3.89,3.89,0,0,1,252,344c.89.05,2.42.53,3.56,2.85.25-1.83,1-4.77,2.93-6a4.6,4.6,0,0,1,4.51.05l-.31.67a3.89,3.89,0,0,0-3.8-.09c-2.57,1.6-2.74,6.89-2.74,6.95Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.06,355.71l-.66-.34c1.48-2.85,4.73-4.9,7.55-4.76a4,4,0,0,1,3.1,1.53,10.85,10.85,0,0,1,4.74-7.08,9.21,9.21,0,0,1,9-.67l-.29.67a8.53,8.53,0,0,0-8.28.62,9.91,9.91,0,0,0-4.5,7.68l0,1.89-.7-1.76a3.28,3.28,0,0,0-3.06-2.14C251.37,351.22,248.42,353.1,247.06,355.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,366.75l-.65-.36c.9-1.64,5.69-9.88,11.36-11.37a5.89,5.89,0,0,1,4.78.69l-.38.63a5.22,5.22,0,0,0-4.21-.61C249.74,356.83,245.44,362.35,243,366.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.14 278.66 316.14 283.29 239.96 327.27 179.82 292.55 179.82 287.92 256 243.94 316.14 278.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.14 278.66 239.96 322.64 179.82 287.92 256 243.94 316.14 278.66",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.14 227.74 316.14 232.36 239.96 276.35 179.82 241.62 179.82 237 256 193.01 316.14 227.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.14 227.74 239.96 271.72 179.82 237 256 193.01 316.14 227.74",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Side--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.7,211.33l-55.6-32.05a3,3,0,0,0-3-.3c-.72.41-3.28,1.9-4,2.31a3,3,0,0,0-1.26,2.77V336.23a9.45,9.45,0,0,0,4.28,7.4l55.6,32.06a3,3,0,0,0,3,.3c.72-.42,3.3-1.9,4-2.33A3,3,0,0,0,244,370.9V218.74A9.45,9.45,0,0,0,239.7,211.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.96 234.69 243.98 232.37 243.98 218.47 239.95 220.79 239.96 234.69",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.16 188.39 324.18 186.08 324.18 172.18 320.15 174.5 320.16 188.39",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.84,338.85l-4,2.31v12.66a2.36,2.36,0,0,0,1.07,1.85l1.87,1.08a2.37,2.37,0,0,0,2.14,0l1.87-1.08a3.82,3.82,0,0,0,1.47-1.78l3.61-10.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.83,353.82a2.36,2.36,0,0,0,1.07,1.85l1.87,1.08a1,1,0,0,0,1.47-.55l3.61-10.41-8-4.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.93,362l-4,2.31v12.66a2.35,2.35,0,0,0,1.06,1.85l1.88,1.08a2.35,2.35,0,0,0,2.13,0l1.88-1.08a3.88,3.88,0,0,0,1.47-1.78l3.6-10.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.93,376.92a2.35,2.35,0,0,0,1.06,1.85l1.88,1.08a1,1,0,0,0,1.47-.55l3.6-10.41-8-4.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.08,181.6l55.61,32.05a9.46,9.46,0,0,1,4.27,7.41V378.2s-3.09-1.83-4.27-2.51l-55.6-32.06a9.45,9.45,0,0,1-4.28-7.4V184.06a2.6,2.6,0,0,1,4.27-2.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.69,213.65,180.08,181.6a2.6,2.6,0,0,0-4.27,2.46v13.59l64.15,37V221.06A9.46,9.46,0,0,0,235.69,213.65Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M312.13,228.11a.38.38,0,0,1-.37-.37V182.08l-43.55,25.14a.35.35,0,0,1-.5-.13.37.37,0,0,1,.13-.51L312,181.12a.35.35,0,0,1,.37,0,.37.37,0,0,1,.18.32v46.3A.37.37,0,0,1,312.13,228.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.11,216.53H304a.37.37,0,0,1-.28-.44l7.46-32.31-14.8,25.63a.36.36,0,0,1-.5.14.37.37,0,0,1-.14-.51l16-27.78a.38.38,0,0,1,.46-.16.37.37,0,0,1,.22.43l-8,34.73A.36.36,0,0,1,304.11,216.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.08,205a.36.36,0,0,1-.27-.12.37.37,0,0,1,0-.52l24.06-23.15a.37.37,0,0,1,.52,0,.38.38,0,0,1,0,.53l-24.06,23.14A.36.36,0,0,1,288.08,205Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.13,220.72h0a.38.38,0,0,1-.37-.37c0-6.06-6.76-6.47-7.05-6.48a.39.39,0,0,1-.28-.15.36.36,0,0,1-.06-.3,7.19,7.19,0,0,0-2.31-6.81,3.45,3.45,0,0,0-2.66-1,1.85,1.85,0,0,0-1.27.86.37.37,0,0,1-.43.17.37.37,0,0,1-.26-.38c0-.23.41-5.62-4.33-6.15a.38.38,0,0,1-.29-.2.37.37,0,0,1,0-.34s2.1-3.93,1.29-5.86a1.56,1.56,0,0,0-1.07-.92.36.36,0,0,1-.25-.46.38.38,0,0,1,.46-.25,2.27,2.27,0,0,1,1.54,1.35c.77,1.83-.53,4.86-1.09,6,3.68.71,4.36,4.18,4.46,5.9a2.82,2.82,0,0,1,1.1-.47,4,4,0,0,1,3.27,1.21,8,8,0,0,1,2.63,7.12c1.62.21,7.34,1.34,7.33,7.18A.37.37,0,0,1,312.13,220.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.13,210.74a.37.37,0,0,1-.37-.34c-.16-2.12-1.39-4.86-2.94-5.54a1.73,1.73,0,0,0-1.87.3.38.38,0,0,1-.41,0,.37.37,0,0,1-.19-.36s.33-3.75-1.36-5.3a3,3,0,0,0-2.68-.6.36.36,0,0,1-.35-.12.38.38,0,0,1-.07-.37c.34-.93,1-3.54.11-4.47-.42-.43-1.19-.47-2.3-.11a.37.37,0,0,1-.42-.14.38.38,0,0,1,0-.44c.62-.78,2.15-3.06,1.77-4.15a.92.92,0,0,0-.74-.56.37.37,0,0,1-.27-.45.35.35,0,0,1,.44-.27,1.62,1.62,0,0,1,1.27,1c.41,1.19-.59,3-1.29,4a2.28,2.28,0,0,1,2.06.53c1.1,1.14.57,3.55.24,4.68a3.48,3.48,0,0,1,2.72.85c1.49,1.36,1.65,4,1.63,5.21a2.35,2.35,0,0,1,2,0c1.89.83,3.2,3.78,3.39,6.17a.36.36,0,0,1-.34.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.67,165.24a3,3,0,0,0-1.76-2.47L272.3,128.35a9.47,9.47,0,0,0-8.55,0l-91.68,52.94a3,3,0,0,0-1.76,2.47v4.63a3,3,0,0,0,1.76,2.47l59.61,34.41a9.41,9.41,0,0,0,8.55,0l91.68-52.93a3,3,0,0,0,1.76-2.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.68,220.64l-59.61-34.41c-2.36-1.37-2.36-3.58,0-4.94l91.68-52.94a9.47,9.47,0,0,1,8.55,0l59.61,34.42c2.37,1.37,2.37,3.57,0,4.94l-91.68,52.93A9.41,9.41,0,0,1,231.68,220.64Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "320.15 179.12 292.09 213.85 243.98 241.63 243.97 223.11 320.15 179.12",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.14 232.36 292.09 264.77 243.98 292.56 243.98 274.03 316.14 232.36",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.14 283.29 292.09 315.7 243.98 343.49 243.98 324.96 316.14 283.29",
    style: {
      opacity: 0.1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "205.78 384.44 132.02 427.03 48.96 378.96 122.72 336.38 205.78 384.44",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.78 384.44 132.02 427.03 48.96 378.96 122.72 336.38 205.78 384.44",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.72 278.65 122.72 336.38 48.96 378.96 48.96 321.24 122.72 278.65",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.72 278.65 122.72 336.38 48.96 378.96 48.96 321.24 122.72 278.65",
    style: {
      opacity: 0.23
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.02 369.3 132.02 427.03 48.96 378.96 48.96 321.24 132.02 369.3",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.02 369.3 132.02 427.03 48.96 378.96 48.96 321.24 132.02 369.3",
    style: {
      opacity: 0.38
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.78 326.71 205.78 384.44 122.72 336.38 122.72 278.65 205.78 326.71",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.78 326.71 205.78 384.44 122.72 336.38 122.72 278.65 205.78 326.71",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.78 384.44 205.78 326.71 132.02 369.3 132.02 427.03 205.78 384.44",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.78 384.44 205.78 326.71 132.02 369.3 132.02 427.03 205.78 384.44",
    style: {
      opacity: 0.23
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.72 278.65 122.82 246.69 205.68 294.81 205.78 326.71 122.72 278.65",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.72 278.65 122.82 246.69 205.68 294.81 205.78 326.71 122.72 278.65",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.02 369.3 138.94 341.34 212.03 299.14 205.78 326.71 132.02 369.3",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.02 369.3 138.94 341.34 212.03 299.14 205.78 326.71 132.02 369.3",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.96 321.24 40.16 292.24 113.92 249.66 122.72 278.65 48.96 321.24",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.96 321.24 40.16 292.24 113.92 249.66 122.72 278.65 48.96 321.24",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.96 321.24 31.6 297.27 114.67 345.33 132.02 369.3 48.96 321.24",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.96 321.24 31.6 297.27 114.67 345.33 132.02 369.3 48.96 321.24",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.74,409.86a.46.46,0,0,1-.46-.45V399.25a.47.47,0,0,1,.46-.46.46.46,0,0,1,.45.46v10.16A.45.45,0,0,1,153.74,409.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.41,402.77a.58.58,0,0,1-.18,0,.47.47,0,0,1-.24-.6l1.62-3.73,1.8,2.08a.46.46,0,0,1-.69.6l-.85-1-1,2.4A.47.47,0,0,1,152.41,402.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.93,407.47a.46.46,0,0,1-.45-.46V396.86a.45.45,0,1,1,.9,0V407A.46.46,0,0,1,157.93,407.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.6,400.38a.58.58,0,0,1-.18,0,.45.45,0,0,1-.23-.6L157.8,396l1.8,2.07a.46.46,0,0,1,0,.64.45.45,0,0,1-.64,0l-.85-1-1,2.4A.46.46,0,0,1,156.6,400.38Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.65,416.75a1,1,0,0,1-.49-.12,1.2,1.2,0,0,1-.55-1.09v-1.25a.46.46,0,0,1,.46-.45.45.45,0,0,1,.45.45v1.25c0,.18,0,.28.09.3s.14,0,.29-.08a2.65,2.65,0,0,0,.85-2.05v-5.2a.45.45,0,1,1,.9,0v5.2a3.44,3.44,0,0,1-1.29,2.83A1.41,1.41,0,0,1,141.65,416.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.88,412.56v-.78a12.87,12.87,0,0,1,5.79-10c1.64-.94,3.2-1.08,4.4-.38a4.33,4.33,0,0,1,1.86,4v.26Zm8.51-10.74a4.7,4.7,0,0,0-2.26.7,12,12,0,0,0-5.3,8.45L148,405.09a3.37,3.37,0,0,0-1.41-3A2.38,2.38,0,0,0,145.39,401.82Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "31.6 297.27 114.67 345.33 132.02 369.3 113.75 346.18 31.6 297.27",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.78 326.71 132.02 369.3 132.02 427.03 133.4 370.46 205.78 326.71",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Moth--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--moth--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.54,303.62c7.61-1.1,14.56-6,19-12.16a29,29,0,0,0,4.5-9.54,20.43,20.43,0,0,0,.46-9.88c-1.37-5.49-6.45-8.74-11.82-9.42a18,18,0,0,0-8.1.79,13.68,13.68,0,0,0-6.7,5A8.28,8.28,0,0,0,93,272.77a2.5,2.5,0,0,0,2.24,2.55,7.22,7.22,0,0,0,4.57-1.16,14.49,14.49,0,0,0,4.27-3.64,30.56,30.56,0,0,0,5.54-10.5,21.09,21.09,0,0,0,0-10,18.46,18.46,0,0,0-4.53-9.21,16.76,16.76,0,0,0-9.74-4.29,23.72,23.72,0,0,0-10.74,1,11.49,11.49,0,0,0-4.13,2.26c-.86.8-1.84,2.12-1.49,3.42s2.25,1.88,3.54,1.71a9.28,9.28,0,0,0,5-2.71,21.35,21.35,0,0,0,3.77-5,8.78,8.78,0,0,0,1.13-4.34c-.13-6.34-7.14-10.44-12.63-11.6a16.25,16.25,0,0,0-4.51-.3c-.51,0-.2.84.21.81A16.48,16.48,0,0,1,84,223.69a14.22,14.22,0,0,1,6.21,5.53,7.61,7.61,0,0,1-.24,7.74,20.53,20.53,0,0,1-3.62,4.62c-1.19,1.08-3,2.33-4.67,2.21a1.47,1.47,0,0,1-1.32-.83,2.13,2.13,0,0,1,.59-1.82A8.37,8.37,0,0,1,84.14,239a21,21,0,0,1,9.49-1.56,17,17,0,0,1,9.34,3,14.69,14.69,0,0,1,4.86,7.71,22.64,22.64,0,0,1,.88,9.5,24.35,24.35,0,0,1-3.63,9c-1.85,3.06-4.17,6-7.65,7.2-.86.31-2.66.76-3-.49s.64-2.79,1.27-3.76a12.72,12.72,0,0,1,5.82-4.91,16.07,16.07,0,0,1,7.29-1.1c4.71.35,9.49,2.81,11.13,7.49a17,17,0,0,1,.26,8.6,27.64,27.64,0,0,1-3.31,8.84A31.58,31.58,0,0,1,102,301.51c-1.48.64-3,1.18-4.55,1.68-.16.06-.09.46.09.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.75,216.8c-4-.29-9.51,2.86-7.55,5.16s7.16-1.42,7.16-1.42-.49,4.65,1.21,5.18,4-3.91,2.3-6.75a5.23,5.23,0,0,0,5-.64c2.42-1.78-.14-3.46-3.55-3.16,0,0,2.44-8-2.49-6.47C65.36,209.45,64.49,212.34,65.75,216.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.75,216.8c-4-.29-9.51,2.86-7.55,5.16s7.16-1.42,7.16-1.42-.49,4.65,1.21,5.18,4-3.91,2.3-6.75a5.23,5.23,0,0,0,5-.64c2.42-1.78-.14-3.46-3.55-3.16,0,0,2.44-8-2.49-6.47C65.36,209.45,64.49,212.34,65.75,216.8Z",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.47,218.5a8,8,0,0,0-.7-.61c-.35-.27-.72-.53-1.07-.79a9.12,9.12,0,0,0-1.07-.67,6.65,6.65,0,0,0-.66-.32,1.83,1.83,0,0,0-1-.16.5.5,0,0,0-.4.78,2.5,2.5,0,0,0,1,.66l.54.29c.37.22.7.47,1,.72s.7.49,1,.74a6.53,6.53,0,0,0,1.71,1,.19.19,0,0,0,.18,0C70.51,219.74,69.76,218.79,69.47,218.5Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.28,106.79c-4.37,5.88-10.22,38.21-12.43,48.58-10.63-.31-24.85-.81-30.23-1.37-6-.63-18.81-1.86-25.1-1-15.61,2-15,12.26-14.62,14.94.41,3.06,2.6,4.46,11,2.55a28.92,28.92,0,0,1,5.72-.67c.81,0,2.52-.41,3.16.28,1,1-1.89,2.68-2.61,3.14-1.11.72-2.27,1.63-2.5,2.93a1.29,1.29,0,0,0,.41,1.33,1.68,1.68,0,0,0,1.27,0,45.08,45.08,0,0,0,11-4.19,25.52,25.52,0,0,1,4.11-2c2.17-.7,4.41-.29,6.59-.29,4.69,0,29.48,2.46,40.5,3.58,7.63.77,8.44-6.76,11.07-14.39C398.85,150.75,406.5,101,406.5,101,398.78,99.88,393.48,99.81,388.28,106.79Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.62,100.22c-3.69-.68-12-1.71-16.52,3.34s-5.59,10.35-7.58,18S377,142.91,377,142.91s5.83,8.37,24.08,6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.45 364.64 439.62 364.65 435.93 336.8 452.12 336.16 452.45 364.64",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.85,350.73c-2.18,3.79-9.19,3.48-15,2.14l-.67-27.38,17.15-.68Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.58,188.66c.46,11.85-1.11,81.92-1.11,81.92.43,3.4,3.95,9.33,4.68,21.6C456.22,310,452.59,348,452.59,348s-7.35,3.84-15.27.9c0,0-8.06-55-11-72.58-2.54-15.3-5.8-56.34-5.8-56.34l-6.33,52.6a87.29,87.29,0,0,1,1.43,18.89c-.26,8.18-4.92,47.9-4.92,47.9a28.49,28.49,0,0,1-16.42.39s-3.82-61.64-4.26-69.11c-.5-8.52-.16-83.73-.16-83.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.54,220s-11.21-3.18-18.85-10c0,0,3.58,6.11,13.72,11.53l-.58,45.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,387.87c-.41.42-.17,3.19.33,3.91s3.56,3.16,8.87,3.34c5.07.16,9.55-.7,12.44-2.7s4.25-4.13,4.42-7-.26-5.66,1-7.93c1.19-2.09,3.12-4.48,3.51-5.61.87-2.45-.19-5.86-.19-5.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.8,362.2a11.11,11.11,0,0,1-.46,3.23,33.1,33.1,0,0,1-4.83,9.51c-1.46,1.87-3.3,3.44-4.85,5.25a10.39,10.39,0,0,0-2.88,6.33c-.06,4,4.3,5.15,7.63,5.61a24.28,24.28,0,0,0,10.74-1,9.87,9.87,0,0,0,6.94-8.18c.14-1.11,0-2.23.12-3.34a15.56,15.56,0,0,1,2.81-7.06,21.55,21.55,0,0,0,2.22-3.86c.93-2.5,0-5.23-.76-7.64-.65-2.09-1.39-4.46-2.12-4.23,0,1.11,0,1.21-.71,2-1,1-.95,2.39-2,3.26a14.16,14.16,0,0,0,.62-2.84,1.63,1.63,0,0,0-.27-1.12,3,3,0,0,0-1.24-.6,24.26,24.26,0,0,0-4.85-.91,14.52,14.52,0,0,0-4.7.15,2.09,2.09,0,0,0-1.16.73,2.42,2.42,0,0,0-.37,1.37C437.68,359.51,437.79,361.14,437.8,362.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,372.73c1.44-1.16,4.74-1.31,6.56-1.18a10.9,10.9,0,0,1,5.21,1.6,1.17,1.17,0,0,0,1.51-.18h0a1.11,1.11,0,0,0-.18-1.68,11.19,11.19,0,0,0-5.87-1.92c-4.46-.13-5.73.68-5.73.68S433.51,371.43,434,372.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.76,376.93c1.81-1.17,5.46-1.16,7.27-1a10.37,10.37,0,0,1,5.08,1.71,1.16,1.16,0,0,0,1.5-.18h0a1.1,1.1,0,0,0-.17-1.68,11.57,11.57,0,0,0-6-2.08c-4.47-.14-5.59.81-5.59.81A3.68,3.68,0,0,0,430.76,376.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.83,365.05a11.06,11.06,0,0,0-5.58.68c-.76.47-1.23,1.73-.72,2a10.31,10.31,0,0,1,4.94-.88,14.6,14.6,0,0,1,4.86,1.14c.39.15.85.37,1.25.57a1.06,1.06,0,0,0,1.45-.51h0a1,1,0,0,0-.44-1.26A14.12,14.12,0,0,0,442.83,365.05Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.53,367.81a4.82,4.82,0,0,0,0,3.56c.44,1.07,5.74,4.39,13.1,4.25A30.68,30.68,0,0,0,394.09,371c2.89-1.72,5.82-1.93,9.46-2s8.5-1.62,9.38-3.28.1-4.63.1-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.23,346.31l-.57-.15a2.47,2.47,0,0,0-1-.09,1.8,1.8,0,0,0-.93.56,18.17,18.17,0,0,0-2,2.86c-1.65,2.43-5,4.36-8.6,6.09-2.46,1.17-4.85,2.06-7.38,3.05s-6,1.55-8,2.79c-3,1.81-3.57,6.66-.39,8.74,2.76,1.8,10.12,3.95,18,2.11,4.31-1,9.25-5.32,14.85-5.49,3.57-.11,10.33-.79,12.74-3.38.91-1.15,0-5-.81-8.32-.84-3.62-.46-9-2.08-9l-.1,1.81c-.15.54-1.42,1.07-1.82,1.49l-1.44,1.52a7.17,7.17,0,0,1-2.12,1.72c-1.43.64-3.1.26-4.63-.14-.06,0,.77-2.78.86-3.05a1.2,1.2,0,0,0,.08-.67,1,1,0,0,0-.43-.53A11.34,11.34,0,0,0,396.23,346.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.55,353.8a3.31,3.31,0,0,1,2.71-1.63c1.63-.22,4.42,1.1,6.13,2.65a1.33,1.33,0,0,1-.3,2.18h0a1.31,1.31,0,0,1-1.5-.24A10.16,10.16,0,0,0,386.55,353.8Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.41,356.37a3.79,3.79,0,0,1,3.18-1.45s4.22.32,6.71,2.88a1.29,1.29,0,0,1-.28,2.1h0a1.28,1.28,0,0,1-1.45-.23A10.14,10.14,0,0,0,381.41,356.37Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.76,358.63a4.25,4.25,0,0,1,3.3-1.29,11.43,11.43,0,0,1,6.42,2.89,1.3,1.3,0,0,1-.28,2.11h0a1.26,1.26,0,0,1-1.45-.24A9.73,9.73,0,0,0,375.76,358.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,100.44c4.72.54,10.3.83,14.81,1.42,5.81.76,10.34,6.77,11.76,16.07,1.56,10.24-5,39.6-5,39.6l2.09,34.62c-8.51,6.27-44.75,9.56-62.81-3.48,0,0,.42-58.92,1.83-68,1.94-12.45,5-20.18,19-21.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.27,175.44c-1.53,2.56-3.07,5.12-4.65,7.65-.58.94-1.17,1.87-1.78,2.79a6.61,6.61,0,0,1-1.15,1.21c-.76.52-2.34.19-3.26.22q-6.78.23-13.52,1a2.57,2.57,0,0,0-2,.86,1.76,1.76,0,0,0,.64,2.24,5.07,5.07,0,0,0,2.43.72l3.9.46a3,3,0,0,1,1.56.5c1.42,1.15-1.29,2.53-2.1,3.09a29.56,29.56,0,0,1-5.19,2.88c-8.13,3.42-9.12,5.9-7.62,8.72,1.3,2.45,6.92,11.36,21.2,3.69,5.75-3.09,14.5-12.85,18.49-17.57,5.74-6.81,15.45-22,15.45-22,5.52-7.58,6.23-10.69,6.36-13.84s-17-27.38-22.82-35.89-8.59-18.86-23.4-20.28c0,0-5.64,17.88,3.7,29.45l21.57,30.09S462.37,171.93,460.27,175.44Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.92,133.71c-2.77-4-5.66-8.12-8.45-12.2-11.75-17.15-10.76-20.29-27.7-20.53-1.5,2.3-2.39,12.2-.13,22.14,1.89,8.35,9,14.24,9,14.24l8.48,11.49s5.19-.16,11.41-4.72A19,19,0,0,0,475.92,133.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.17,55.37a8.45,8.45,0,0,0-7.85-3.7l-.88,21.47L429,81.07l.25,8.83A5,5,0,0,0,433.11,87c1.32-2.54,5-14.82,5-14.82h0C441.41,62.09,440.71,57.53,439.17,55.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.44,73.24a7.57,7.57,0,0,1,2.07-3.42c1.23-1.32,6.13-2.75,8.36,1.41s-1.53,9.65-4.43,11.33c-3.71,2.16-5.89-.78-5.89-.78l.09,19.77h0c-1.73,4-9.54,7.56-14.19,7-3.7-.47-7.11-3.38-3.8-7.62l-.27-5.64s-4.95,1-7.4.75c-4.07-.42-6.78-3.49-8.22-7.81-2.32-6.94-3.35-12.58-2.37-26.5,1.08-15.25,18.71-16.28,28.54-10.76S429.44,73.24,429.44,73.24Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.78,45.89c-.45-3.33.7-6.9,4.19-8.08a7.37,7.37,0,0,1,7.74,1.29,6.74,6.74,0,0,1,12-1.27,6.58,6.58,0,0,1,4-2.79,7.76,7.76,0,0,1,5.94,1.08c1.42,1.05,3.09,3,2.67,5.53,2.81-1.13,5.74-.19,7.83,2.29a8.85,8.85,0,0,1,2,5.37,7.16,7.16,0,0,1-.43,3c-.4.91-1.22,1.51-1.46,2.54a7.93,7.93,0,0,0-.53,2.84c.23,1.68.6,3.36.82,5a40.63,40.63,0,0,1,.41,4.93,2.73,2.73,0,0,1-1.21,1.92,7.74,7.74,0,0,0-2.11,3c-.35.72-.69,2.5-1.38,3-2.13,1.49-2.37-3.33-2.47-4.26a50.05,50.05,0,0,1,0-6.41,7.7,7.7,0,0,1-5.67-2.6,6.64,6.64,0,0,1-1.41-3.14,10.8,10.8,0,0,1-.16-2c-1.39,2.3-4.62,3.24-6.92,3-3.86-.35-5.19-2-5.81-3.21a7.67,7.67,0,0,1-1.53,3.26,8.73,8.73,0,0,1-3.47,2,6.37,6.37,0,0,1-6.31-1.82c-1.57,2.25-5.55,1.25-6.43.62-2-1.45-2.65-3.18-2.87-5.65s.78-5.29,3.52-6.26A9.87,9.87,0,0,1,387.78,45.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.38,95.26s8.94-2.26,12-4.1a10.39,10.39,0,0,0,4.15-4.54,14.27,14.27,0,0,1-2.23,5.22c-2.16,3.07-13.82,5.83-13.82,5.83Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.88,72.58a1.94,1.94,0,1,0,1.84-2.11A2,2,0,0,0,411.88,72.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.89,87.05a2.5,2.5,0,1,0,2.36-2.73A2.57,2.57,0,0,0,408.89,87.05Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.49,65.92l4.12,2a2.42,2.42,0,0,0-1.09-3.15A2.24,2.24,0,0,0,413.49,65.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.57,67.65l3.51-3a2.21,2.21,0,0,0-3.2-.33A2.43,2.43,0,0,0,395.57,67.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.62,72.19a1.88,1.88,0,1,0,1.78-2A1.91,1.91,0,0,0,396.62,72.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.9 69.97 405.84 81.8 399.58 80 405.9 69.97",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.19,86.52a.44.44,0,0,0,.28-.2.45.45,0,0,0-.12-.64l-5.44-3.62a.46.46,0,0,0-.64.13.45.45,0,0,0,.13.64l5.43,3.62A.43.43,0,0,0,390.19,86.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.61,88.86a.48.48,0,0,0,.35-.35.47.47,0,0,0-.35-.56l-6.36-1.47a.46.46,0,0,0-.56.34.47.47,0,0,0,.35.56l6.36,1.48A.74.74,0,0,0,389.61,88.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.7,93.09l.06,0,6.13-2.24a.46.46,0,1,0-.32-.87l-6.13,2.24a.46.46,0,0,0-.27.6A.46.46,0,0,0,383.7,93.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.84,141.06a1.45,1.45,0,0,0,2.66-.15l4.56-11.25a1.45,1.45,0,1,0-2.72-1l-4.57,11.25A1.45,1.45,0,0,0,331.84,141.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.33,141a1.45,1.45,0,0,0,2.75-.66l-.15-14a1.45,1.45,0,0,0-2.89,0l.14,14A1.45,1.45,0,0,0,324.33,141Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.6,133.21l.09.17,6.89,10a1.45,1.45,0,0,0,2,.4,1.47,1.47,0,0,0,.39-2l-6.89-10a1.44,1.44,0,0,0-2.49,1.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrder);
export default __webpack_public_path__ + "static/media/no_order.b039fd26458cb08fed65a05d8ca7fec2.svg";
export { ForwardRef as ReactComponent };